<div class="mat-elevation-z8">
  <mat-table
    matSort
    [dataSource]="dataSource"
    (matSortChange)="sortData($event)"
    [matSortActive]="activeSortColumn"
    [matSortDirection]="activeSortDirection"
    matSortDisableClear
  >
    <!-- reference_id Column -->
    <ng-container matColumnDef="mqs_reference_id">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="first-header-cell"> BQX Quote Number </mat-header-cell>
      <mat-cell *matCellDef="let element" class="first-header-cell"> {{ element.mqs_reference_id }} </mat-cell>
    </ng-container>

    <!-- first_name Column -->
    <ng-container matColumnDef="mqs_first_name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> First Name </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.mqs_first_name }} </mat-cell>
    </ng-container>

    <!-- last_name Column -->
    <ng-container matColumnDef="mqs_last_name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.mqs_last_name }} </mat-cell>
    </ng-container>

    <!-- business_name Column -->
    <ng-container matColumnDef="mqs_business_name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Business Name </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.mqs_business_name }} </mat-cell>
    </ng-container>

    <!-- last_name Column -->
    <ng-container matColumnDef="mqs_phone">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Phone Number </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.mqs_phone }} </mat-cell>
    </ng-container>

    <!-- last_name Column -->
    <ng-container matColumnDef="mqs_email">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Email Address</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.mqs_email }} </mat-cell>
    </ng-container>

    <!-- last_name Column -->
    <ng-container matColumnDef="mqs_route">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Routing </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.mqs_route }} </mat-cell>
    </ng-container>

    <!-- last_name Column -->
    <ng-container matColumnDef="mqs_focused">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Consumer Last Viewed </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.mqs_focused }} </mat-cell>
    </ng-container>

    <!-- last_name Column -->
    <ng-container matColumnDef="mqs_created_at">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Created At </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.mqs_created_at }} </mat-cell>
    </ng-container>

    <!-- action Column -->
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <a class="button-link" (click)="viewButtonOnClick(element.id, element.mqs_reference_id)" type="submit">
          View
        </a>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
